var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepintegration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.527 4.734a1.778 1.778 0 1 0-1.362.409l.56 1.866a3.91 3.91 0 1 0 5.266 5.266l1.866.56a1.778 1.778 0 1 0 .409-1.362l-1.867-.56q.023-.209.023-.424c0-.823-.254-1.587-.689-2.217l3.24-3.239a1.778 1.778 0 1 0-1.006-1.006l-3.24 3.24a3.9 3.9 0 0 0-2.64-.666zM8 10.49a2.489 2.489 0 1 1-4.978 0 2.489 2.489 0 0 1 4.978 0",
  clipRule: "evenodd",
  opacity: 0.8
})));
export { SvgStepintegration as ReactComponent };
export default __webpack_public_path__ + "static/media/step.integration.fbd57cfc.svg";